import { getBusinessKyc } from "@/services/kyc.service";
import { useQuery } from "@tanstack/react-query";

export const useBusinessKyc = (merchantId, enabled = true, options = {}) => {
  return useQuery({
    queryKey: ["business-kyc", merchantId],
    queryFn: async () => {
      const response = await getBusinessKyc({ merchantId });
      return response.data;
    },
    enabled: enabled && !!merchantId,
    ...options,
  });
};
